import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/views/layouts/Layout';

import servicePointsRouter from './modules/service-points';

Vue.use(Router);

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/Home.vue'),
      hidden: true
    },
    {
      path: '/connect',
      name: 'ConnectBike',
      component: () => import('@/views/auth/ConnectBike.vue'),
      hidden: true
    },
    {
      path: '/connect/failed/:fail',
      name: 'ConnectFailed',
      component: () => import('@/views/auth/ConnectBikeFailed.vue'),
      hidden: true
    },
    {
      path: '/vinrecheck',
      name: 'VinRecheck',
      component: () => import('@/views/auth/FramenumberRecheck.vue'),
      hidden: true
    },
    {
      path: '/coverbikedata',
      name: 'CoverBikeData',
      component: () => import('@/views/auth/CoverBikeData.vue'),
      hidden: true
    },
    {
      path: '/changebike',
      name: 'ChangeBike',
      component: () => import('@/views/auth/ChangeBike.vue'),
      hidden: true
    },
    {
      path: '/re-fwupdate',
      name: 'ReFwUpdate',
      component: () => import('@/views/auth/ReFwUpdate.vue'),
      hidden: true
    },
    {
      path: '/writevin',
      name: 'WriteFramenumber',
      component: () => import('@/views/auth/WriteFrameNumber.vue'),
      hidden: true
    },
    servicePointsRouter,
    {
      path: '/support',
      name: 'Support',
      component: Layout,
      redirect: '/support',
      meta: { title: 'support', icon: '' },
      children: [
        {
          path: '',
          name: '',
          component: () => import('@/views/reference/Support.vue'),
          meta: { title: 'support' }
        }
      ]
    }
  ]
});
